'use client';

import { Box, Divider } from '@wishket/design-system';

import PopularArticles from '../PopularArticles';

import { EmptySearch } from '@/features/Search';
import { useSearchResult } from '@/shared/providers/SearchProvider';
import { ArticleListGridLayout } from '@/shared/Components';

interface SearchedEmptyProps {
  searchQuery: string;
}

const SearchedEmpty = ({ searchQuery }: SearchedEmptyProps) => {
  const { isEmptySearch } = useSearchResult();

  if (!isEmptySearch) return null;

  return (
    <>
      <ArticleListGridLayout>
        <EmptySearch searchQuery={searchQuery} />
        <Divider />
      </ArticleListGridLayout>
      <ArticleListGridLayout isNotGridAtMobile>
        <Box className="-mt-2 flex w-full flex-col items-center gap-6 overflow-x-scroll pt-2 grid-in-content scrollbar-hide tablet:gap-10 desktop:px-0">
          <PopularArticles />
        </Box>
      </ArticleListGridLayout>
    </>
  );
};

export default SearchedEmpty;
